<template>
  <MessageLayout image="./aws-token-expired.svg" title="Trial license expired">
    Your trial license has expired or has already been used.
  </MessageLayout>
</template>

<script setup lang="ts">
import MessageLayout from "@/modules/messages/MessageLayout.vue";
</script>
